module.exports = __webpack_public_path__ + "static/media/genzongbiao61.dfded774.png";